import { createStandardAction } from 'typesafe-actions';
export var SET_FILE = 'SET_FILE';
export var setFile = createStandardAction(SET_FILE)();